<div class="admin-restaurants">
  <header class="page-header">
    <div class="header-content">
      <h1>
        <i class="fas fa-store"></i>
        Gestion des Restaurants
      </h1>
      <p class="subtitle">Gérez tous les restaurants partenaires</p>
    </div>
    <div class="header-actions">
      <button (click)="exportRestaurants()" class="btn btn-secondary">
        <i class="fas fa-download"></i>
        Exporter
      </button>
      <a class="btn btn-primary" routerLink="/admin/restaurants/new">
        <i class="fas fa-plus"></i>
        Nouveau restaurant
      </a>
    </div>
  </header>

  <!-- Statistiques -->
  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon total">
        <i class="fas fa-store"></i>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ store.totalRestaurants() }}</span>
        <span class="stat-label">Total</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon active">
        <i class="fas fa-check-circle"></i>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ store.activeRestaurants() }}</span>
        <span class="stat-label">Actifs</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon pending">
        <i class="fas fa-clock"></i>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ store.pendingRestaurants() }}</span>
        <span class="stat-label">En attente</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon revenue">
        <i class="fas fa-euro-sign"></i>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{
          store.totalRevenue() | oskCurrency: 'EUR' : 'symbol' : '1.0-0'
        }}</span>
        <span class="stat-label">Revenus total</span>
      </div>
    </div>
  </div>

  <!-- Filtres -->
  <div class="filters-section">
    <div class="search-box">
      <i class="fas fa-search"></i>
      <input
        (ngModelChange)="onSearch($event)"
        [(ngModel)]="searchTerm"
        placeholder="Rechercher un restaurant..."
        type="text"
      />
    </div>
    <div class="filter-group">
      <select (ngModelChange)="onFilterChange()" [(ngModel)]="statusFilter">
        <option value="">Tous les statuts</option>
        <option value="active">Actif</option>
        <option value="inactive">Inactif</option>
        <option value="pending">En attente</option>
        <option value="suspended">Suspendu</option>
      </select>
      <select (ngModelChange)="onFilterChange()" [(ngModel)]="cuisineFilter">
        <option value="">Toutes les cuisines</option>
        <option value="french">Française</option>
        <option value="italian">Italienne</option>
        <option value="japanese">Japonaise</option>
        <option value="chinese">Chinoise</option>
        <option value="indian">Indienne</option>
        <option value="mexican">Mexicaine</option>
        <option value="american">Américaine</option>
        <option value="other">Autre</option>
      </select>
      <select (ngModelChange)="onSortChange()" [(ngModel)]="sortBy">
        <option value="name">Nom</option>
        <option value="rating">Note</option>
        <option value="orders">Commandes</option>
        <option value="revenue">Revenus</option>
        <option value="createdAt">Date création</option>
      </select>
    </div>
  </div>

  <!-- Liste des restaurants -->
  <div class="restaurants-container">
    @if (store.loading()) {
      <div class="loading-state">
        <div class="spinner"></div>
        <p>Chargement des restaurants...</p>
      </div>
    } @else if (store.error()) {
      <div class="error-state">
        <i class="fas fa-exclamation-circle"></i>
        <p>{{ store.error() }}</p>
        <button (click)="refreshRestaurants()" class="btn btn-primary">
          Réessayer
        </button>
      </div>
    } @else if (filteredRestaurants().length === 0) {
      <div class="empty-state">
        <i class="fas fa-store-slash"></i>
        <h3>Aucun restaurant trouvé</h3>
        <p>Ajoutez votre premier restaurant partenaire.</p>
        <a class="btn btn-primary" routerLink="/admin/restaurants/new">
          <i class="fas fa-plus"></i>
          Ajouter un restaurant
        </a>
      </div>
    } @else {
      <div class="restaurants-grid">
        @for (restaurant of filteredRestaurants(); track restaurant.id) {
          <div [class]="'status-' + restaurant.status" class="restaurant-card">
            <div class="card-header">
              <div class="restaurant-image">
                @if (restaurant.imageUrl) {
                  <img [alt]="restaurant.name" [src]="restaurant.imageUrl" />
                } @else {
                  <div class="image-placeholder">
                    <i class="fas fa-store"></i>
                  </div>
                }
              </div>
              <div [class]="restaurant.status" class="status-badge">
                {{ getStatusLabel(restaurant.status) }}
              </div>
            </div>

            <div class="card-body">
              <h3 class="restaurant-name">{{ restaurant.name }}</h3>
              <div class="restaurant-cuisine">
                <i class="fas fa-utensils"></i>
                {{ restaurant.cuisineType || 'Non défini' }}
              </div>

              <div class="restaurant-info">
                <div class="info-item">
                  <i class="fas fa-map-marker-alt"></i>
                  <span>{{ restaurant.city || 'Non renseigné' }}</span>
                </div>
                <div class="info-item">
                  <i class="fas fa-star"></i>
                  <span
                    >{{ restaurant.rating | number: '1.1-1' }} ({{
                      restaurant.reviewsCount
                    }}
                    avis)</span
                  >
                </div>
              </div>

              <div class="restaurant-stats">
                <div class="stat">
                  <span class="stat-value">{{ restaurant.ordersCount }}</span>
                  <span class="stat-label">Commandes</span>
                </div>
                <div class="stat">
                  <span class="stat-value">{{
                    restaurant.menuItemsCount
                  }}</span>
                  <span class="stat-label">Articles</span>
                </div>
                <div class="stat">
                  <span class="stat-value">{{
                    restaurant.revenue | oskCurrency: 'EUR' : 'symbol' : '1.0-0'
                  }}</span>
                  <span class="stat-label">Revenus</span>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <!-- Bouton de validation pour les restaurants en attente -->
              @if (restaurant.status === 'pending') {
                <div class="pending-actions">
                  <button
                    (click)="approveRestaurant(restaurant)"
                    class="btn btn-success"
                  >
                    <i class="fas fa-check"></i>
                    Valider
                  </button>
                  <button
                    (click)="deleteRestaurant(restaurant)"
                    class="btn btn-danger"
                  >
                    <i class="fas fa-times"></i>
                    Refuser
                  </button>
                </div>
              } @else {
                <div class="card-actions">
                  <a
                    [routerLink]="['/admin/restaurants', restaurant.id, 'edit']"
                    class="btn btn-icon"
                    title="Modifier"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <button
                    (click)="viewOrders(restaurant)"
                    class="btn btn-icon"
                    title="Voir les commandes"
                  >
                    <i class="fas fa-shopping-cart"></i>
                  </button>
                  <button
                    (click)="viewMenu(restaurant)"
                    class="btn btn-icon"
                    title="Voir le menu"
                  >
                    <i class="fas fa-list"></i>
                  </button>
                  @if (restaurant.status !== 'suspended') {
                    <button
                      (click)="suspendRestaurant(restaurant)"
                      class="btn btn-icon warning"
                      title="Suspendre"
                    >
                      <i class="fas fa-ban"></i>
                    </button>
                  }
                  <button
                    (click)="deleteRestaurant(restaurant)"
                    class="btn btn-icon danger"
                    title="Supprimer"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </div>

                <div class="toggle-status">
                  <label class="toggle">
                    <input
                      (change)="toggleRestaurantStatus(restaurant)"
                      [checked]="restaurant.status === 'active'"
                      [disabled]="restaurant.status === 'suspended'"
                      type="checkbox"
                    />
                    <span class="toggle-slider"></span>
                  </label>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>

  <!-- Pagination -->
  @if (store.totalPages() > 1) {
    <div class="pagination">
      <button
        (click)="goToPage(store.currentPage() - 1)"
        [disabled]="store.currentPage() === 0"
        class="btn btn-icon"
      >
        <i class="fas fa-chevron-left"></i>
      </button>

      <span class="page-info">
        Page {{ store.currentPage() + 1 }} sur {{ store.totalPages() }}
      </span>

      <button
        (click)="goToPage(store.currentPage() + 1)"
        [disabled]="store.currentPage() >= store.totalPages() - 1"
        class="btn btn-icon"
      >
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  }
</div>
